/**
 * created by lei lei
 *原创稿件
 */
import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {Button, Empty, Input, message, Pagination, Popconfirm, Popover, Tabs, TreeSelect, Modal,  Dropdown, Menu, Table} from "antd";
import {connect} from "react-redux";
import {Scrollbars} from "react-custom-scrollbars";
import ManuscriptPoolItem from "../components/manuscriptPool/ManuscriptPoolItem";
import ManuscriptTable from "../components/manuscriptPool/ManuscriptTable";
import * as utils from "../../utils";
import RelationTaskDetail from "../components/manuscriptPool/RelationTaskDetail";
import RelationSelectTopicDetail from "../components/manuscriptPool/RelationSelectTopicDetail";
import {HEADER_HEIGHT} from "../../constants";
import * as actions from "../../actions/originalManuscript";
import * as Actions from "../../actions/manuscriptListId";
import visitVioletSource from "../components/manuscriptPool/img/visitVioletSource.png";
import visitGraySource from "../components/manuscriptPool/img/visitGraySource.png";
import AddToEditor from '../../components/resource-list/addToEditor';
import {
    shrinNavigateStauts, updataNavigateData,
    updateNavigateLevel2Data
} from "../../actions";
import { getPublishData, withdraw, delManuscript,getInterviewId } from '../../actions/publishContent';
import PublishInfoModal from "../publishContent/publishInfoModal";

import card from '../../view/components/manuscriptPool/img/card2.png'
import otherCard from '../../view/components/manuscriptPool/img/otherCard.png'
import list from '../../view/components/manuscriptPool/img/list2.png'
import otherList from '../../view/components/manuscriptPool/img/otherList.png'

const {TabPane} = Tabs;
const {Search} = Input;
const { TextArea } = Input;
const { confirm } = Modal;

class OriginalManuscript extends Component {
    static defaultProps = {};
    static propTypes = {
        title: PropTypes.string.isRequired,//标题必须添加
        mediaType: PropTypes.string.isRequired,//媒体类型
    };

    constructor(props) {
        super(props);
        this.actions = actions;
        this.state = {
            mediaType: this.props.mediaType,
            selectKey: '1',//上面的大筛选
            searchValue: '',//搜索文字
            page: 1,//当前页
            size: 10,//每页条数,
            topRedNum: 0,//待我处理的红字
            dataList: [],
            listTotal: 0,
            publishList: [],//访问的数据
            visibleStatus: false,//访问的弹出框状态
            current: {},
            pickUpList: [],
            mediaList: [],
            mediaCode: '',
            startMediaType:'1',
            selectUpOrDownType:'1',
            visible:false,
            publishInfo:{},
            showType:"list",   //展示类型
            listChecked:true,
            cardChecked:false,
        }
    }
    
    componentWillMount() {
    }

    componentDidMount() {
        this.state.pickUpList = [];
        this.state.selectKey = '1';
        this.state.searchValue = '';
        this.state.page = 1;
        this.state.size = 10;
        this.state.mediaCode = '';
        this.setState({
            pickUpList: [], selectKey: '1',//上面的大筛选
            searchValue: '',//搜索文字
            page: 1,//当前页
            size: 10,//每页条数,
        });

        //获取其他媒体

        if (this.props.mediaType === 'other') {
            //如果没有已定稿直接查已发布
            let showFinalizedStatus=this.props.config && this.props.config.getValueByKey ? this.props.config.getValueByKey("show.finalized", '0') : '0';
            let showFinalized=showFinalizedStatus==='0'?false:true
            if(!showFinalized){
                this.state.selectKey = '5';
            }
            this.getOtherMedia();
        } else {
            this.state.mediaType = this.props.mediaType;
            this.state.startMediaType=this.props.mediaType
            this.typeChange();
            if (this.props.title === '任务稿件') {
                this.getMyHandle()//获取待处理角标
            }
        }


    }

    //获取其他媒体
    getOtherMedia() {
        let mediaCode = this.props.match.params.mediaCode;
        let mediaList = [{
            title: '网站',
            value: 'web',
            key: 'web',
            disabled: true,
            children: []
        },
            {
                title: '公众号',
                value: 'wechat',
                key: 'wechat',
                disabled: true,
                children: []
            }];
        this.state.mediaCode = '';
        //获取全部媒体
        let otherAllList = [];
        window.loading&&window.loading.show();
        this.actions.getAllMedia(data => {
            if (data && data.length) {
                data.forEach(item => {
                    if (item.code !== mediaCode) {

                        item.title = item.name;
                        item.key = item.code;
                        item.value = item.code;
                        item.type = item.type;
                        otherAllList.push(item);
                        if (item.type === 1) {
                            mediaList[0].children.push(item)
                        } else if (item.type === 2) {

                            mediaList[1].children.push(item)
                        }
                    }else{
                        this.state.startMediaType=item.type.toString();
                    }

                })
            }
            window.loading&&window.loading.hide();
            if (otherAllList.length) {
                for (let i=0;i<mediaList.length;i++){
                    let item =mediaList[i];
                    if(item.children.length>0){
                        this.state.mediaCode =  item.children[0] ? item.children[0].code : '';
                        this.state.mediaType = item.children[0].type.toString();
                        break;
                    }
                }
               /* this.state.mediaCode =  mediaList[0].children[0] ? mediaList[0].children[0].code : '';
                this.state.mediaType = otherAllList[0].type.toString();*/
                console.log(this.state.mediaCode, this.state.mediaType);
                this.getOtherResources()
            }
            this.setState({mediaList})
        })

    }

    //其他媒体稿件
    getOtherResources() {
        window.loading&&window.loading.show();
        let showFinalizedStatus=this.props.config && this.props.config.getValueByKey ? this.props.config.getValueByKey("show.finalized", '0') : '0';
        let showFinalized=showFinalizedStatus==='0'?false:true
        if(!showFinalized){
            this.state.selectKey = '5';
        }
        let body = {
            start: this.state.page,
            size: this.state.size,
            mediaCode: this.state.mediaCode
        };
        switch (this.state.selectKey) {
            case "1"://所有稿件
                break;
            case "2"://待我处理
                body.type = 'toDoList';
                break;
            case "3"://审核中
                body.type = 'process';
                break;
            case "4"://已定稿
                body.statusName = '审核通过';
                break;
            case "5"://已发布
                body.statusName = '发布';
                break;
        }

        if (this.state.searchValue) {
            body.queryStr = this.state.searchValue
        }
        let dataList = [];
        let listTotal = 0;
        this.actions.getPublishResource(body, data => {
            if (data && data.data) {
                dataList = data.data;
                listTotal = data.count;
            }
            window.loading&&window.loading.hide();

            this.setState({
                dataList: dataList,
                listTotal: listTotal,
            });
            setTimeout(() => {
                this.scrollRef && this.scrollRef.scrollToTop();
            });
        })
    }

    typeChange() {

        if (this.props.mediaType === 'other') {
            this.getOtherResources();
        } else {
            this.state.mediaCode = this.props.match.params.mediaCode;
            if (this.props.title === '任务稿件') {
                this.getOriginalList();
               // this.getMyHandle();
            } else if (this.props.title === '投稿稿件') {
                this.getResourcePool()
            }
        }
    }

    getMyHandle() {
        let mediaCode = this.props.match.params.mediaCode;
        this.state.mediaCode = mediaCode;
        let body = {
            start: this.state.page,
            size: this.state.size,
            type: 'toDoList',
            mediaCode: mediaCode
        };
        let topRedNum = 0;
        this.actions.getOriginalList(body, data => {
            if (data.count) {
                topRedNum = data.count;
            }
            this.setState({
                topRedNum: topRedNum,
            });


        })
    }

    //任务稿件
    getOriginalList() {
        let mediaCode = this.props.match.params.mediaCode;
        if (mediaCode) {
            window.loading&&window.loading.show();
            let body = {
                start: this.state.page,
                size: this.state.size,
                mediaCode: mediaCode
            };

            switch (this.state.selectKey) {
                case "1"://所有稿件
                    break;
                case "2"://待我处理
                    body.type = 'toDoList';
                    break;
                case "3"://审核中
                    body.type = 'process';
                    break;
                case "4"://已定稿
                    body.statusName = '审核通过';
                    break;
                case "5"://已发布
                    body.statusName = '发布';
                    break;
            }

            if (this.state.searchValue) {
                body.queryStr = this.state.searchValue
            }
            let dataList = [];
            let listTotal = 0;
            this.actions.getOriginalList(body, data => {
                if (data && data.data) {
                    dataList = data.data;
                    listTotal = data.count;
                    if(this.state.selectKey==='2'){
                        this.state.topRedNum=data.count
                    }
                }
                window.loading&&window.loading.hide();

                this.setState({
                    dataList: dataList,
                    listTotal: listTotal,
                });
                setTimeout(() => {
                    this.scrollRef && this.scrollRef.scrollToTop();
                });
            })
        }
    }


    //投稿稿件
    getResourcePool() {
        let mediaCode = this.props.match.params.mediaCode;
        if (mediaCode) {
            window.loading&&window.loading.show();
            let body = {
                start: this.state.page,
                size: this.state.size,
                mediaCode: mediaCode
            };
            if (this.state.searchValue) {
                body.queryStr = this.state.searchValue
            }
            let dataList = [];
            let listTotal = 0;
            this.actions.getResourcePool(body, data => {
                if (data && data.data) {
                    dataList = data.data;
                    listTotal = data.count;
                }
                window.loading&&window.loading.hide();
                this.setState({
                    dataList: dataList,
                    listTotal: listTotal,
                });
                setTimeout(() => {
                    this.scrollRef && this.scrollRef.scrollToTop();
                });
            })
        }
    }

    findUrlData = (url) => {
        let sons;
        let name;
        let stopFind = false;
        let find = (data, level, levelOneBrothers, levelOneName) => {
            if (stopFind)
                return;
            if ((!data.sons || data.sons.length === 0) && (!data.float_ || data.float_.length === 0)) {
                if (data.path === url) {
                    sons = levelOneBrothers;
                    name = levelOneName;
                    stopFind = true;
                }
                return;
            }
            let tempSons = data.float_;
            if (!tempSons || tempSons.length === 0) {
                tempSons = data.sons;
            }
            if (stopFind)
                return;
            tempSons && tempSons.map(item => {
                if (stopFind)
                    return;
                let tempItemSons = item.float_;
                if (!tempItemSons || tempItemSons.length === 0) {
                    tempItemSons = item.sons;
                }
                if (level == 0) {//取第一级的信息
                    find(item, level + 1, tempItemSons, item.name);
                } else {
                    find(item, level + 1, levelOneBrothers, levelOneName);
                }
            })
        };
        find({sons: this.props.navigateData}, 0, null, null);
        return {stopFind, sons, name};
    };

    goPublish = () => {
        let {stopFind, sons, name} = this.findUrlData('/view/weChatPublish/'+this.props.match.params.mediaCode);
        if (stopFind) {
            this.props.shrinNavigateStauts();
            this.props.updateNavigateLevel2Data(name, sons);
            this.props.history.push('/view/weChatPublish/'+this.props.match.params.mediaCode)  
            return;
        }
    }

    handlePublish = () => {
        //调用发布的接口
        if(!this.state.publishInfo.publishUrl){
            message.info('请输入发布链接');
            return
        }
        actions.publish(this.state.publishInfo,(res) => {
            this.state.publishInfo.publishUrl='';
            this.state.publishInfo.remark='';
            this.setState({
                visible: false,
                page: 1,
            },() => {
                this.typeChange();
            });
        })
       
    }

    changePublishInfo = (e,type) => {
        let publishInfo = this.state.publishInfo;
        publishInfo[type] =  e.target.value;
        this.setState({
            publishInfo
        })
    }

    // 选中类型
    checkedList=()=>{
        this.setState({
            showType:"list",
            listChecked:true,
            cardChecked:false
        })
    }
    checkedCard=()=>{
        this.setState({
            showType:"block",
            cardChecked:true,
            listChecked:false
        })
    }

    render() {
      //  console.log(1111111111111111,'拾取至的数据', this.state.pickUpList,this.state.mediaType,typeof this.state.mediaType, this.state.mediaCode,this.state.startMediaType);
        let height = window.innerHeight - HEADER_HEIGHT;//上部分70//
        let newSecondSelectColor = this.props.config && this.props.config.getValueByKey ? this.props.config.getValueByKey("newSecondSelectColor", '#0050B3') : '#0050B3';
        let topRedNum = this.state.topRedNum;
        if (topRedNum > 99) {
            topRedNum = '(99+)';
        } else {
            topRedNum = '(' + topRedNum + ')';
        }

        let title = this.props.title;
        let showFinalizedStatus=this.props.config && this.props.config.getValueByKey ? this.props.config.getValueByKey("show.finalized", '0') : '0';
        let showFinalized=showFinalizedStatus==='0'?false:true

        let tabList = [];
        if (title === '任务稿件') {
            tabList=[{title: '所有稿件', key: '1'}, {title: '待我处理', key: '2'}, {title: '审核中', key: '3'}];
            if(showFinalized){
                tabList.push( {
                    title: '已定稿',
                    key: '4'
                })
            }
            tabList.push({title: '已发布', key: '5'})
           /* tabList = [{title: '所有稿件', key: '1'}, {title: '待我处理', key: '2'}, {title: '审核中', key: '3'}, {
                title: '已定稿',
                key: '4'
            }, {title: '已发布', key: '5'}];*/
        }
        if (title === '投稿稿件') {
            tabList = [];
        }
        if (title === '其他媒体稿件') {
            tabList =[] //[{title: '所有稿件', key: '1'}];
            if(showFinalized){
                tabList.push({title: '所有稿件', key: '1'});
                tabList.push({title: '已定稿', key: '4'});
                tabList.push({title: '已发布', key: '5'})
            }

           // tabList = [{title: '所有稿件', key: '1'}, {title: '已定稿', key: '4'}, {title: '已发布', key: '5'}];
        }
        return (
            <>
            <div style={{height: height}}>
                <div style={{display: 'flex', background: '#ffffff'}}>
                    <b style={{
                        color: newSecondSelectColor,
                        fontSize: 18,
                        height: 58,
                        lineHeight: '58px',
                        marginLeft: 20
                    }}>
                        {this.props.title}
                    </b>
                    {this.props.mediaType === 'other' ?
                        <div style={{display: 'flex', lineHeight: '58px', marginLeft: 20}}>
                            <div><b>选择媒体</b></div>
                            <div style={{width: 180}}>
                                <TreeSelect
                                    /* showSearch*/
                                    style={{width: '100%', paddingLeft: 10, fontSize: 16, color: '#a4adc8'}}
                                    value={this.state.mediaCode}
                                    dropdownStyle={{maxHeight: 400, overflow: 'auto'}}
                                    placeholder="请选择"
                                    treeDefaultExpandAll
                                    treeData={this.state.mediaList}
                                    onChange={(value, title, item) => {
                                        //  console.log(title,item)
                                        let type = item.triggerNode.props.type.toString();
                                        this.state.mediaType = type;
                                        this.state.selectUpOrDownType=type;
                                        this.state.mediaCode = value;
                                        this.state.page = 1;
                                        this.state.size = 10;
                                        this.setState({});
                                        this.typeChange();
                                    }
                                    }
                                />
                            </div>

                        </div> : null}
                    <div className={'origin'} style={{visibility:tabList.length?'':'hidden',margin: 'auto', height: 58, paddingTop: 13, width: this.props.title === '其他媒体稿件' ? 'calc( 100% - 455px)' : (this.props.title === '任务稿件' ? 'calc( 100% - 165px )': ''), paddingLeft: this.props.title === '任务稿件' ? 'calc(50% - 262px)' : 'calc(50% - 576px)' }}>
                        <Tabs defaultActiveKey={this.state.selectKey} activeKey={this.state.selectKey}
                              onChange={(key) => {
                                  this.state.page = 1;
                                  this.state.size = 10;
                                  this.state.selectKey = key;
                                  this.setState({});
                                  this.typeChange();
                              }} tabBarGutter={0}>
                            {
                                tabList.map((item, i) => {
                                    if (item.title === '待我处理') {
                                        return (
                                            <TabPane tab={<div>
                                                <div> 待我处理</div>
                                                {
                                                    this.state.topRedNum > 0 ? <div style={{
                                                        width: 31,
                                                        height: 16,
                                                        background: '#ff5b57',
                                                        color: 'white',
                                                        fontSize: 12,
                                                        position: 'absolute',
                                                        top: 5,
                                                        right: -13,
                                                        textAlign: 'center',
                                                        borderRadius: '8px',
                                                        lineHeight: '16px',
                                                        cursor: 'pointer',
                                                        margin: 'auto',
                                                        fontWeight: 'normal'
                                                    }}>{this.state.topRedNum < 100 ? this.state.topRedNum : '99+'}
                                                    </div> : null
                                                }</div>} key={'2'}></TabPane>
                                        )
                                    }
                                    return (
                                        <TabPane tab={item.title} key={item.key}></TabPane>
                                    )
                                })
                            }
                            {/* <TabPane tab={"所有稿件"} key={'1'}></TabPane>
                            <TabPane tab={<div style={{display: 'flex'}}>
                                <div> 待我处理</div>
                                {
                                    this.state.topRedNum > 0 ? <div style={{
                                        width: 31,
                                        height: 16,
                                        background: '#ff5b57',
                                        color: 'white',
                                        fontSize: 12,
                                        position: 'absolute',
                                        top: 5,
                                        right: -13,
                                        textAlign: 'center',
                                        borderRadius: '8px',
                                        lineHeight: '16px',
                                        cursor: 'pointer',
                                        margin: 'auto',
                                        fontWeight: 'normal'
                                    }}>{this.state.topRedNum < 100 ? this.state.topRedNum : '99+'}
                                    </div> : null
                                }</div>} key={'2'}></TabPane>
                            <TabPane tab={"审核中"} key={'3'}></TabPane>
                            <TabPane tab={"已定稿"} key={'4'}></TabPane>
                            <TabPane tab={"已发布"} key={'5'}></TabPane>*/}
                        </Tabs>
                        <style>
                            {`
                          
            
            .origin  .ant-tabs-bar .ant-tabs-tab-active {
              color:${newSecondSelectColor}!important ;
              font-weight:bold !important;
             font-size:16px !important;
                }
                .origin  .ant-tabs-nav-container  {
             font-size:16px !important;
                }
              .origin .ant-tabs-ink-bar{
                background-color:  ${newSecondSelectColor} !important;
                }
               .origin  .ant-tabs-nav .ant-tabs-tab {
               color: #6c748b;
               font-weight:bold !important;
               }
             .origin  .ant-tabs-nav .ant-tabs-tab:hover {
                color: ${newSecondSelectColor} !important;
            }
                             `}
                        </style>
                    </div>
                    <table border="0" cellPadding="0" cellSpacing="0" width={70} height={58}> 
                        <tbody>
                            <tr>
                                <td valign={"middle"}>
                                    <style>
                                        {`
                                            .tableChangeBtn {
                                                width:25px;height:25px;cursor:pointer;
                                            }
                                        `}
                                    </style>
                                    <img onClick={this.checkedList} className={"tableChangeBtn"} src={this.state.listChecked?card:otherCard} title={"列表模式"} alt="列表模式"/>
                                    <img onClick={this.checkedCard} className={"tableChangeBtn"} src={this.state.cardChecked?list:otherList} title={"卡片模式"} alt="卡片模式"/>
                                </td>
                            </tr>
                        </tbody>
                    </table>   
                </div>

                <div style={{paddingLeft: 20, paddingRight: 20,}}>

                    <div style={{background: '#f2f2f2', height: 61, lineHeight: '61px'}}>
                        <div style={{float: 'right', display: 'flex'}}>
                            <div style={{marginLeft: 20,}}>
                                <Search
                                    placeholder="请输入搜索内容"
                                    onSearch={value => this.onSearch(value)}
                                    value={this.state.searchValue}
                                    onChange={(e) => {
                                        this.setState({
                                            searchValue: e.target.value
                                        })
                                    }}
                                    style={{width: 200}}
                                />
                            </div>

                        </div>

                    </div>
                    <div style={{height: height - 176, background: 'white'}}>
                        <Scrollbars ref={Scrollbars => this.scrollRef = Scrollbars}>
                            {
                                this.state.dataList.length === 0 ? <div style={{ height: '100%', display: 'flex', justifyContent:'center', alignItems:'center'}}><Empty/></div> : null
                            }
                            {
                                this.state.showType==="list"&&this.state.dataList.length?
                                <ManuscriptTable mediaType={this.props.mediaType} dataList={this.state.dataList}
                                newSecondSelectColor={newSecondSelectColor}
                                titleClick={(item) => {
                                    this.itemTitleClick(item)
                                }}
                                title={this.props.title}
                                 mediaCode={this.props.match.params.mediaCode}
                                task1Click={(item) => {
                                    if (item.interview&&item.interview.id) {
                                        this.RelationTaskDetail.taskDetailShow(item.interview.id);
                                    }
                                }}
                                task2Click={(item) => {
                                    if (item.topicSelection && item.topicSelection.id) {
                                        this.RelationSelectTopicDetail.selectTopicDetailDetailShow(item.topicSelection.id);
                                    }
                                }}
                                btn=
                                    {
                                        (submitStatusName, item, newSecondSelectColor,i)=>this.renderBtns(submitStatusName, item, newSecondSelectColor,i)
                                    }
                                showType={"originalManuscript"}
                                manuscriptType={this.props.title}
                                                 getInterviewIds={(id)=>this.getInterviewIds(id)}
                                />:
                                this.state.dataList.map((item, i) => {
                                    let submitStatusName = '';
                                    if (item.copyStorys&&item.copyStorys.length > 0&&this.props.title!=="投稿稿件") {
                                        item.copyStorys.forEach(copyStoryItem => {
                                            if (copyStoryItem.statusName === '发布') {
                                                submitStatusName = '已发布';
                                                return;
                                            }
                                        });
                                        if (submitStatusName !== '已发布') {
                                            if (item.statusName === '发布') {
                                                submitStatusName = '已发布';
                                            } else {
                                                submitStatusName = item.statusName;
                                            }
                                        }
                                    } else {
                                        if (item.statusName === '发布') {
                                            submitStatusName = '已发布';
                                        } else {
                                            submitStatusName = item.statusName;
                                        }
                                    }

                                    let sex = item.submitUser && item.submitUser.sex ? item.submitUser.sex : 1;
                                    if (this.props.currentUser)
                                        sex = this.props.currentUser.sex;
                                    let photo = "images/header_boys.png";
                                    if (sex === 2) {
                                        photo = "/cm-sites/images/header_girls.png";
                                    }
                                    let usingName='';
                                    if(this.props.mediaType==='other'){
                                        if(item.usingMediaCodes&&item.usingMediaCodes.length>0&&item.usingMediaCodes.indexOf(this.props.match.params.mediaCode)>-1){
                                            usingName= <span style={{color:'#00A854'}}>已采用</span>;
                                        }else{
                                            usingName= <span  style={{color:'#FFBF00'}}>未采用</span> ;
                                        }
                                    }
                                    return (
                                        <ManuscriptPoolItem key={i} newSecondSelectColor={newSecondSelectColor}
                                                            title={item.title}
                                                            submitStatusName={submitStatusName}
                                                            usingName={usingName}
                                                            submitTime={''}
                                                            createTime={item.submitDate && item.submitDate.time ? utils.formatDate(item.submitDate.time) : ''}
                                                            changeTime={item.changeDate && item.changeDate.time ? utils.formatDate(item.changeDate.time) : ''}
                                                            mark={item.summary}
                                                            content={item.content}
                                                            task1={item.interview && item.interview.id ? item.interview.title : ''}
                                                            task2={item.topicSelection && item.topicSelection.id ? item.topicSelection.tsName : ''}
                                                            name={item.submitUser ? item.submitUser.name : ''}
                                                            titlePic={item.titlePic}
                                                            userPic={item.submitUser && item.submitUser.photoUrl ? item.submitUser.photoUrl : photo}
                                                            titleClick={() => {
                                                                this.itemTitleClick(item)
                                                            }}
                                                            task1Click={() => {
                                                                if (item.interview && item.interview.id) {
                                                                    this.RelationTaskDetail.taskDetailShow(item.interview.id);
                                                                }
                                                            }}
                                                            task2Click={() => {
                                                                if (item.topicSelection && item.topicSelection.id) {
                                                                    this.RelationSelectTopicDetail.selectTopicDetailDetailShow(item.topicSelection.id);
                                                                }
                                                            }}
                                                            btn=
                                                                {
                                                                    this.renderBtn(submitStatusName, item, newSecondSelectColor)
                                                                }
                                        />
                                    )
                                //   }
                                })
                            }
                        </Scrollbars>
                    </div>

                </div>
                <div style={{padding: 10, float: 'right'}}>
                    <Pagination
                        showQuickJumper
                        // defaultCurrent={2}
                        current={this.state.page}
                        pageSize={this.state.size}
                        total={this.state.listTotal}
                        showTotal={total => `共 ${total} 条`}
                        showSizeChanger
                        onChange={(page, pageSize) => this.onChange(page, pageSize)}
                        onShowSizeChange={(page, pageSize) => {
                            this.onChange(page, pageSize)
                        }}
                    />
                </div>
                <RelationTaskDetail ref={RelationTaskDetail => this.RelationTaskDetail = RelationTaskDetail}/>
                <RelationSelectTopicDetail
                    ref={RelationSelectTopicDetail => this.RelationSelectTopicDetail = RelationSelectTopicDetail}/>

                <Modal
                    title="访问内容"
                    visible={this.state.visibleStatus}
                    onOk={() => {
                    }}
                    width={600}
                    bodyStyle={{height: 350, background: '#f4f6fc', padding: 20}}
                    onCancel={() => {
                        this.setState({visibleStatus: false})
                    }}
                    footer={null}
                >
                    <div style={{background: '#ffffff', height: 310, padding: 20}}>
                        <Scrollbars style={{height:280}}>
                        {this.state.publishList.map((publishItem, publishIndex) => {
                            return (
                                <div key={publishIndex} style={{
                                    cursor: 'pointer',
                                    height: 46,
                                    lineHeight: '46px',
                                    paddingLeft: 30,
                                    background: publishItem.column === this.state.current.column ? '#f4f6fc' : null
                                }}>
                                    <div onClick={() => {
                                        this.setState({current: publishItem});

                                    }} style={{
                                        float: 'left',
                                        fontSize: 16,
                                        color: publishItem.column === this.state.current.column ? newSecondSelectColor : '#6c748b'
                                    }}>{publishItem.column?publishItem.column:publishItem.url}</div>
                                    <div style={{float: 'right', width: 76, textAlign: 'center'}}><img onClick={() => {
                                        this.setState({current: publishItem});
                                        window.open(publishItem.url)
                                    }}
                                                                                                       src={publishItem.column === this.state.current.column ? visitVioletSource : visitGraySource}
                                                                                                       style={{
                                                                                                           width: 16,
                                                                                                           height: 16,
                                                                                                       }}
                                                                                                       alt=""/></div>
                                </div>
                            )
                        })}
                        </Scrollbars>
                    </div>
                </Modal>
                <div style={{ position: 'relative'}}>
                {this.state.startMediaType==='2' && this.state.dataList.length > 0 ? <AddToEditor list={this.state.pickUpList} changeList={(pickUpList)=>{
                   this.setState({pickUpList})
                }} submit={(pickUpList)=>{
                    let parms={data:[],mediaCode:this.props.match.params.mediaCode}
                    pickUpList.map(item=>{
                        parms.data.push({id:item.id,type:item.newType})
                    })
                    this.actions.addToEditor(parms,(res) => {
                        if(res.state){
                            this.goPublish();
                        }else {
                            message.error('未查询到！')
                        }
                    })
                }} />:null}

                </div>

            </div>
           <Modal
           title = "确认发布"
           visible = {this.state.visible}
           onOk={ this.handlePublish}
           onCancel= { () => { this.setState({ visible: false })}}
           >
               <div>
                   <div style={{ display: 'flex', paddingBottom: 20}}>
                       <span style={{ width: 90, textAlign: 'right'}}>发布链接：</span>
                       <Input value={this.state.publishInfo.publishUrl} onChange={(e) => { this.changePublishInfo(e,'publishUrl')}}/>
                   </div>
                   <div style={{ display: 'flex'}}>
                       <span style={{ width: 90, textAlign: 'right'}}>备注：</span>
                       <TextArea rows={4} value={this.state.publishInfo.remark} onChange={(e) => { this.changePublishInfo(e,'remark')}} />
                   </div>
               </div>
           </Modal>
           <PublishInfoModal ref={(publishInfo) => this.publishInfo = publishInfo} />
           </>
       )
    }

    //渲染底部按钮
    renderBtn(submitStatusName, item, newSecondSelectColor,i) {
        console.log('----------------------',this.state.startMediaType,this.state.mediaType);
        if (this.state.startMediaType === '1') {
          return   this.renderWebBtn(submitStatusName, item, newSecondSelectColor,i);//渲染网站的按钮
        } else if (this.state.startMediaType === '2') {
            return this.renderWechatBtn(submitStatusName, item, newSecondSelectColor,i);//渲染微信的按钮
        } else if( this.state.startMediaType === '6' ) {
            return this.renderOtherBtn(submitStatusName, item, newSecondSelectColor,i);//渲染otherMedia的按钮
        } else {
            return this.renderPreviewBtn(submitStatusName, item, newSecondSelectColor);//渲染微博、抖音的按钮（只有预览）
        }
    }

    //渲染微信微博按钮
    renderPreviewBtn(submitStatusName, item, newSecondSelectColor){

        return (
            <div  style={{display: 'flex', float: 'right'}}>
                {
                    this.props.title !== '其他媒体稿件' ?
                        <div className={'customBtn'} style={{
                            fontsize: 15,
                            color: newSecondSelectColor,
                            cursor: 'pointer',
                            paddingLeft: 10,
                            paddingRight: 10
                        }} onClick={() => {
                            this.review(item);
                        }}><b>预览</b></div> : ''
                }
                <style>{`
                                                    .customBtn :hover{
                                                    color:${newSecondSelectColor}
                                                    }
                                                    
                                                    `} </style>
            </div>
        )

    }
    //列表渲染底部按钮
    renderBtns(submitStatusName, item, newSecondSelectColor,i) {
        if (this.state.startMediaType === '1') {
          return   this.renderWebBtns(submitStatusName, item, newSecondSelectColor,i);//渲染网站的按钮
        } else if (this.state.startMediaType === '2') {
            return this.renderWechatBtns(submitStatusName, item, newSecondSelectColor,i);//渲染微信的按钮
        } else if( this.state.startMediaType === '6' ) {
            return this.renderOtherBtns(submitStatusName, item, newSecondSelectColor,i);//渲染otherMedia的按钮
        }

    }
    //渲染otherMedia按钮
    renderOtherBtn(submitStatusName, item, newSecondSelectColor,i){
        return (
            <div  style={{display: 'flex', float: 'right'}}>
                <div className={'customBtn'} style={{
                    fontsize: 15,
                    color: newSecondSelectColor,
                    cursor: 'pointer',
                    paddingLeft: 10,
                    paddingRight: 10
                }} onClick={() => {
                    window.open(`/cm-sites/pms/printHtmlDetail.html?resourceId=${item.resourceId}`, '_blank');
                }}><b>打印</b></div>
                   {
                    this.props.title !== '其他媒体稿件' ? 
                    <div className={'customBtn'} style={{
                        fontsize: 15,
                        color: newSecondSelectColor,
                        cursor: 'pointer',
                        paddingLeft: 10,
                        paddingRight: 10
                    }} onClick={() => {
                        this.review(item);
                    }}><b>预览</b></div> : ''
                }
                <div className={'customBtn'} id="downloadmenu" style={{
                    fontsize: 15,
                    color: newSecondSelectColor,
                    cursor: 'pointer',
                    paddingLeft: 10,
                    paddingRight: 10
                }} onClick={() => {
                   // this.itemDownload(item)
                }}><Dropdown overlay={this.getMenu(item)} arrow placement="bottomCenter" getPopupContainer={() => document.getElementById('downloadmenu')}><b>下载稿件</b></Dropdown></div>
                {
                    submitStatusName === '已发布' ?
                       null :
                        <div className={'customBtn'} style={{
                            fontsize: 15,
                            color: newSecondSelectColor,
                            cursor: 'pointer',
                            paddingLeft: 10,
                            paddingRight: 10
                        }} onClick={() => { let publishInfo = { storyId: item.id,mediaCode: this.state.mediaCode, ...this.state.publishInfo }; publishInfo.publishUrl='';
                            publishInfo.remark=''; this.setState({ visible: true, publishInfo }) }}>
                            <b>确认发布</b>
                        </div>
                }
                <style>{`
                                                    .customBtn :hover{
                                                    color:${newSecondSelectColor}
                                                    }
                                                    
                                                    `} </style>
            </div>
        )

    }
    //渲染web按钮
    renderWebBtn(submitStatusName, item, newSecondSelectColor) {
        return (
            <div  style={{display: 'flex', float: 'right'}}>
                <div className={'customBtn'} style={{
                    fontsize: 15,
                    color: newSecondSelectColor,
                    cursor: 'pointer',
                    paddingLeft: 10,
                    paddingRight: 10
                }} onClick={() => {
                    window.open(`/cm-sites/pms/printHtmlDetail.html?resourceId=${item.resourceId}`, '_blank');
                }}><b>打印</b></div>
                   {
                    this.props.title !== '其他媒体稿件' ? 
                    <div className={'customBtn'} style={{
                        fontsize: 15,
                        color: newSecondSelectColor,
                        cursor: 'pointer',
                        paddingLeft: 10,
                        paddingRight: 10
                    }} onClick={() => {
                        this.review(item);
                    }}><b>预览</b></div> : ''
                }
                {
                    submitStatusName === '已发布'&&this.state.mediaType!=='2'?
                        <div className={'customBtn'} style={{
                            fontsize: 15,
                            color: newSecondSelectColor,
                            cursor: 'pointer',
                            paddingLeft: 10,
                            paddingRight: 10
                        }} onClick={() => {

                            this.itemLook(item)
                        }}><b>访问</b></div> : null
                }
                <div className={'customBtn'} id="downloadmenu" style={{
                    fontsize: 15,
                    color: newSecondSelectColor,
                    cursor: 'pointer',
                    paddingLeft: 10,
                    paddingRight: 10
                }} onClick={() => {
                   // this.itemDownload(item)
                }}><Dropdown overlay={this.getMenu(item)} arrow placement="bottomCenter" getPopupContainer={() => document.getElementById('downloadmenu')}><b>下载稿件</b></Dropdown></div>
                {
                    this.props.title === '投稿稿件' ?
                        <div className={'customBtn'} style={{
                            fontsize: 15,
                            color: newSecondSelectColor,
                            cursor: 'pointer',
                            paddingLeft: 10,
                            paddingRight: 10
                        }} onClick={() => {
                            this.itemOperation(item)
                        }}><b>移除</b></div> : null
                }
                {
                    this.props.title=== '其他媒体稿件'? <div className={'customBtn'} style={{
                        fontsize: 15,
                        color: newSecondSelectColor,
                        cursor: 'pointer',
                        paddingLeft: 10,
                        paddingRight: 10
                    }} onClick={() => {
                        this.itemUse(item)
                    }}><b>采用</b></div>:null
                }


                <style>{`
                                                    .customBtn :hover{
                                                    color:${newSecondSelectColor}
                                                    }
                                                    
                                                    `} </style>
            </div>
        )

    }
    //渲染微信按钮
    renderWechatBtns(submitStatusName, item, newSecondSelectColor) {
        let operateType=[];
        operateType.push({title:"打印",onClick:() => {window.open(`/cm-sites/pms/printHtmlDetail.html?resourceId=${item.resourceId}`,'_blank')}})
        if(this.props.title !== '其他媒体稿件'){
        operateType.push({title:"预览",onClick:() => { this.review(item);}})
            }
        operateType.push({title:"下载稿件",onClick:() => {}})
        operateType.push({title:"拾取至合成器",onClick:() => {this.pickUp(item)}})
        // if(submitStatusName !== '已发布'){
        //     operateType.push({title:"确认发布",onClick:() => {let publishInfo = { storyId: item.id,mediaCode: this.state.mediaCode, ...this.state.publishInfo }; publishInfo.publishUrl='';
        //             publishInfo.remark=''; this.setState({ visible: true, publishInfo })}})
        // }
        if(submitStatusName === '已发布'&&this.state.mediaType!=='2'){
            operateType.push({title:"访问",onClick:() => {this.itemLook(item)}})
        }
            if(this.props.title ==='投稿稿件'){
                operateType.push({title:"移除",onClick:() => {this.itemOperation(item)}})
            }

        return(
            <div style={{display: 'flex', float: 'right'}}>{
                 operateType.map((items,index)=>{
                     if(items.title==="下载稿件"){
                         return(
                            <div id="downloadmenu" key={index} style={{
                                fontsize: 15, color: newSecondSelectColor,cursor: 'pointer',marginRight:"10px"
                            }} onClick={items.onClick}>
                                <Dropdown overlay={this.getMenu(item)} arrow placement="bottomCenter" getPopupContainer={() => document.getElementById('downloadmenu')}><b>下载稿件</b></Dropdown>
                            </div>
                         )
                     }
                     if(operateType.length>4){
                         let element=operateType.splice(3)
                         operateType.push({
                             title:"更多操作",
                             onClick:this.getMoreMenu(element,newSecondSelectColor)
                         })
                     }
                          if(items.title==="更多操作"){
                                 return(
                                    <div key={index} id="downloadMoremenu" style={{fontsize: 15, color: newSecondSelectColor,cursor: 'pointer',marginRight:"10px"}}>
                                        <Dropdown overlay={items.onClick} arrow placement="bottomCenter" getPopupContainer={() => document.getElementById('downloadMoremenu')}><b>更多操作</b></Dropdown>
                                    </div>
                                 )
                             }
                    return(<div key={index} style={{
                        fontsize: 15, color: newSecondSelectColor,cursor: 'pointer',marginRight:"10px"
                    }} onClick={items.onClick}>{items.title}</div>)                  
            })
            }                   
            </div>                                                               
        )
    }

    //渲染otherMedia按钮
    renderOtherBtns(submitStatusName, item, newSecondSelectColor,i){
      
        let operateType=[];
        operateType.push({title:"打印",onClick:() => {window.open(`/cm-sites/pms/printHtmlDetail.html?resourceId=${item.resourceId}`,'_blank')}})
        if(this.props.title !== '其他媒体稿件'){
        operateType.push({title:"预览",onClick:() => { this.review(item);}})
            }
        operateType.push({title:"下载稿件",onClick:() => {}})
        if(submitStatusName !== '已发布'&& submitStatusName !== '撤回'){
            operateType.push({title:"确认发布",onClick:() => {let publishInfo = { storyId: item.id,mediaCode: this.state.mediaCode, ...this.state.publishInfo };  publishInfo.publishUrl='';
                    publishInfo.remark='';this.setState({ visible: true, publishInfo })}})
        }
        return(
            <div style={{display: 'flex', float: 'right'}}>{
                 operateType.map((items,index)=>{
                     if(items.title==="下载稿件"){
                         return(
                            <div key={index} id="downloadmenu" style={{
                                fontsize: 15, color: newSecondSelectColor,cursor: 'pointer',marginRight:"10px"
                            }} onClick={items.onClick}>
                                <Dropdown overlay={this.getMenu(item)} arrow placement="bottomCenter" getPopupContainer={() => document.getElementById('downloadmenu')}><b>下载稿件</b></Dropdown>
                            </div>
                         )
                     }
                     if(operateType.length>4){
                         let element=operateType.splice(3)
                         operateType.push({
                             title:"更多操作",
                             onClick:this.getMoreMenu(element,newSecondSelectColor)
                         })
                     }
                          if(items.title==="更多操作"){
                                 return(
                                    <div key={index} id="downloadMoremenu" style={{fontsize: 15, color: newSecondSelectColor,cursor: 'pointer',marginRight:"10px"}}>
                                        <Dropdown overlay={items.onClick} arrow placement="bottomCenter" getPopupContainer={() => document.getElementById('downloadMoremenu')}><b>更多操作</b></Dropdown>
                                    </div>
                                 )
                             }
                    return(<div key={index} style={{
                        fontsize: 15, color: newSecondSelectColor,cursor: 'pointer',marginRight:"10px"
                    }} onClick={items.onClick}>{items.title}</div>)                  
            })
            }                   
            </div>                                                               
        )
    }

     //撤回
     revert = (item) => {
          //调用撤回接口
          confirm({
            title: '确定撤回此稿件?',
            onOk: () => {
                //调用撤回接口
                withdraw({ id: item.id }, (res) => {
                    this.setState({
                        page: 1
                    }, () => {
                        this.typeChange();
                    })
                })
            },
            onCancel: () => {
                //cancel
            },
        });
    }

    //渲染web按钮
    renderWebBtns(submitStatusName, item, newSecondSelectColor) {
        let operateType=[];
        operateType.push({title:"打印",onClick:() => {window.open(`/cm-sites/pms/printHtmlDetail.html?resourceId=${item.resourceId}`,'_blank')}})
        if(this.props.title !== '其他媒体稿件'){
        operateType.push({title:"预览",onClick:() => { this.review(item);}})
            }
        operateType.push({title:"下载稿件",onClick:() => {}})
        if(submitStatusName === '已发布'&&this.state.mediaType!=='2'){
            operateType.push({title:"访问",onClick:() => {this.itemLook(item)}})
        }
            if(this.props.title === '投稿稿件'){
                operateType.push({title:"移除",onClick:() => {this.itemOperation(item)}})
            }
        if(this.props.title=== '其他媒体稿件'){
            operateType.push({title:"采用",onClick:() => {this.itemUse(item)}})
        }
        return(
            <div style={{display: 'flex', float: 'right'}}>{
                 operateType.map((items,index)=>{
                     if(items.title==="下载稿件"){
                         return(
                            <div key={index} id="downloadmenu" style={{
                                fontsize: 15, color: newSecondSelectColor,cursor: 'pointer',marginRight:"10px"
                            }} onClick={items.onClick} key={index}>
                                <Dropdown overlay={this.getMenu(item)} arrow placement="bottomCenter" getPopupContainer={() => document.getElementById('downloadmenu')}><b>下载稿件</b></Dropdown>
                            </div>
                         )
                     }
                     if(operateType.length>4){
                         let element=operateType.splice(3)
                         operateType.push({
                             title:"更多操作",
                             onClick:this.getMoreMenu(element,newSecondSelectColor)
                         })
                     }
                          if(items.title==="更多操作"){
                                 return(
                                    <div key={index} id="downloadMoremenu" style={{fontsize: 15, color: newSecondSelectColor,cursor: 'pointer',marginRight:"10px"}}>
                                        <Dropdown overlay={items.onClick} arrow placement="bottomCenter" getPopupContainer={() => document.getElementById('downloadMoremenu')}><b>更多操作</b></Dropdown>
                                    </div>
                                 )
                             }
                    return(<div key={index} style={{
                        fontsize: 15, color: newSecondSelectColor,cursor: 'pointer',marginRight:"10px"
                    }} onClick={items.onClick}>{items.title}</div>)                  
            })
            }                   
            </div>                                                               
        )
    }

    getMenu = (item,newSecondSelectColor) => {
        return(
            <Menu>
                <Menu.Item>
                   <span style={{color:newSecondSelectColor}} onClick = { () =>{ this.itemDownload(item)}}>压缩包</span>
                </Menu.Item>
                <Menu.Item>
                <span style={{color:newSecondSelectColor}}  onClick = { () =>{ window.open(`/cm-sites/pms/printHtmlDetail.html?resourceId=${item.resourceId}&download=true`,'_blank');}}>文档</span>
                </Menu.Item>
            </Menu>
        )
    }

    getMoreMenu= (item,newSecondSelectColor) => {
        return(
            <Menu>
                {
                    item.map((i,index)=>{
                        return(
                            <Menu.Item>
                   <span onClick = {i.onClick}>
                       {
                           i.title==="下载稿件"?
                           <div key={index} id="downloadmenu" style={{
                            fontsize: 15, color: newSecondSelectColor,cursor: 'pointer',marginRight:"10px"
                        }}>
                            <Dropdown overlay={this.getMenu(item)} arrow placement="topCenter" getPopupContainer={() => document.getElementById('downloadmenu')}><b>下载稿件</b></Dropdown>
                        </div>
                           :i.title
                       }
                       </span>
                </Menu.Item>
                        )
                
                    })
                }
                
            </Menu>
        )
    }


    //渲染微信按钮
    renderWechatBtn(submitStatusName, item, newSecondSelectColor) {
        return (
            <div style={{display: 'flex', float: 'right'}}>
                <div className={'customBtn'} style={{
                    fontsize: 15,
                    color: newSecondSelectColor,
                    cursor: 'pointer',
                    paddingLeft: 10,
                    paddingRight: 10
                }} onClick={() => {
                    window.open(`/cm-sites/pms/printHtmlDetail.html?resourceId=${item.resourceId}`, '_blank');
                }}><b>打印</b></div>
                {
                    this.props.title !== '其他媒体稿件' ? 
                    <div className={'customBtn'} style={{
                        fontsize: 15,
                        color: newSecondSelectColor,
                        cursor: 'pointer',
                        paddingLeft: 10,
                        paddingRight: 10
                    }} onClick={() => {
                        this.review(item);
                    }}><b>预览</b></div> : ''
                }
                <div className={'customBtn'} style={{
                    fontsize: 15,
                    color: newSecondSelectColor,
                    cursor: 'pointer',
                    paddingLeft: 10,
                    paddingRight: 10
                }} onClick={() => {
                    this.pickUp(item)
                }}><b>拾取至合成器</b></div>
                {
                    submitStatusName === '已发布'&&this.state.mediaType!=='2' ?
                        <div className={'customBtn'} style={{
                            fontsize: 15,
                            color: newSecondSelectColor,
                            cursor: 'pointer',
                            paddingLeft: 10,
                            paddingRight: 10
                        }} onClick={() => {

                            this.itemLook(item)
                        }}><b>访问</b></div> : null
                }
                <div className={'customBtn'} id="downloadmenu" style={{
                    fontsize: 15,
                    color: newSecondSelectColor,
                    cursor: 'pointer',
                    paddingLeft: 10,
                    paddingRight: 10
                }} onClick={() => {
                   // this.itemDownload(item)
                }}> <Dropdown overlay={this.getMenu(item)} arrow placement="bottomCenter" getPopupContainer={() => document.getElementById('downloadmenu')}><b>下载稿件</b></Dropdown></div>
                {
                    (this.props.title=== '投稿稿件' ?
                        <div className={'customBtn'} style={{
                            fontsize: 15,
                            color: newSecondSelectColor,
                            cursor: 'pointer',
                            paddingLeft: 10,
                            paddingRight: 10
                        }} onClick={() => {
                            this.itemOperation(item)
                        }}><b>移除</b></div> : null)

                }


                <style>{`
                                                    .customBtn :hover{
                                                    color:${newSecondSelectColor}
                                                    }
                                                    
                                                    `} </style>
            </div>
        )

    }

    //搜索
    onSearch(value) {
        this.state.searchValue = value;
        this.state.page = 1;
        this.state.size = 10;
        this.typeChange();
    }

    //标题点击
    itemTitleClick(item) {
     
        // mediaType: 3(微博) 5（抖音）外来资源下只可预览不能操作
        if(["2","3","5",'6'].includes(this.state.mediaType)){
            window.open('/cm-sites/pms/framereact/index.html?#/preview/page/'+item.id+'/1','_blank');
            return;
        }

        let url;//1任务稿件，2，投稿稿件，3.其他稿件，
        let isShowMainColumnSetBtn=this.state.startMediaType === '1'?'true':'false';
     if(this.props.title==='任务稿件'){
         url = "/cm-sites/pms/addContribute/addContributeNews.html?eiditStoryId="+item.id+/*"&interviewId="+(item.interview?item.interview.id:'')+"&actButtonId=2&passMediaCodes="+this.state.mediaCode+*/'&currentMediaCode='+this.state.mediaCode+'&isShowMainColumnSetBtn='+isShowMainColumnSetBtn;
     }else if(this.props.title==='投稿稿件'){
         url = "/cm-sites/pms/addContribute/addContributeNews.html?eiditStoryId=" + item.id
             + "&currentMediaCode=" + this.state.mediaCode + "&actButtonId=2" + "&fromZyk=true&passMediaCodes="+this.state.mediaCode+'&currentMediaCode='+this.state.mediaCode+'&isShowMainColumnSetBtn='+isShowMainColumnSetBtn;
     }else if(this.props.title==='其他媒体稿件'){
         let type=1;
         if(this.state.mediaType==='1'){
             type=1;
         }else if(this.state.mediaType==='2'){
             type=6;
         }
         window.open('/cm-sites/pms/framereact/index.html?#/preview/page/'+item.id+'/'+type,'_blank');
         return;
     }

        let that = this;
       window.openFull(url, "新建稿件", null, {
            shade: 0.5,
            area: [parseInt(window.document.body.clientWidth * 0.9) + 'px', parseInt(window.document.body.clientHeight * 0.9) + 'px']
        }, null, function () {
            that.typeChange();
        })
    }

    //查看访问
    itemLook(item) {
        let storyId = item.id;
        // storyId=1305;//测试id
        let body = {
            storyId: storyId
        };
        let publishList = [];
        this.actions.getWebsiteStoryPublishUrl(body, data => {
            if (data && data.length > 0) {
                data.forEach(item => {
                    item.checked = false;
                });
                publishList = data;
            }
            if (publishList.length > 0) {
                this.state.visibleStatus = true;
            } else {
                this.state.visibleStatus = false;
                message.info('没有查询到相关数据')

            }
            this.setState({publishList, current: {}});
        })
    }


    //拾取
    pickUp(item) {

        if(this.state.pickUpList.length===8){
            message.info('最多只可拾取8篇');
            return;
        }
        if (this.state.pickUpList.length === 0) {
            item.newType=this.state.selectUpOrDownType==='1'?1:(this.state.selectUpOrDownType==='2'?6:0);
            this.state.pickUpList.push(item)
        } else {
            let needPush = true;
            this.state.pickUpList.forEach(picItem => {
                if (item.id === picItem.id) {
                    needPush = false;
                }
            });
            if (needPush) {
                item.newType=this.state.selectUpOrDownType==='1'?1:(this.state.selectUpOrDownType==='2'?6:0);
                this.state.pickUpList.push(item)
            }
        }
        this.setState({})
    }

    //下载稿件
    itemDownload(item) {
        let body = {
            storyId: item.id,
        };
        this.actions.downloadStoryById(body, data => {
            window.open(data)
        })
    }

    itemOperation(item) {
        this.itemRemove(item)
    }

    //删除
    itemDelete(item) {
        let body = {
            storyId: item.id,
        };
        this.actions.delStoryById(body, data => {
            if (data) {
                message.info('删除成功')
                this.typeChange();//刷新列表
            }
        })
    }

    //移除
    itemRemove(item) {
        let body = {
            storyId: item.id,
            deleteMediaCode: this.state.mediaCode
        };
        this.actions.removeResource(body, data => {
            if (data) {
                message.info('删除成功')
                this.typeChange();//刷新列表
            }
        })
    }

    //采用
    itemUse(item){
        let  copyType;
        if(this.state.mediaType==='1'){
            copyType='story'
        }else if(this.state.mediaType==='2'){
            copyType='stuff'
        }else if(this.state.mediaType==='3'){
            copyType='weibo'
        }
        let url='/cm-sites/pms/addContribute/addContributeNews.html?copyType='+copyType+'&srcId='+item.id+'&actButtonId=2&fromZyk=true&currentMediaCode='+this.props.match.params.mediaCode;//1任务稿件，2，投稿稿件，3.其他稿件，


        let that = this;
        window.openFull(url, "稿件", null, {
            shade: 0.5,
            area: [parseInt(window.document.body.clientWidth * 0.9) + 'px', parseInt(window.document.body.clientHeight * 0.9) + 'px']
        }, null, function () {
            that.typeChange();
        })
    }

    //翻页
    onChange(page, pageSize) {
        this.state.page = page;
        this.state.size = pageSize;
        this.typeChange()

    }

    //预览
    review(item){
        if(item.linkurl){
            window.open(item.linkurl,'_blank');
        }else{
            window.open('/cm-sites/pms/framereact/index.html?#/preview/page/'+item.id+'/1','_blank');
        }
    }

}

function mapStateToProps(state) {
    return {
        config: state.systemReducer.config,
        currentUser: state.systemReducer.currentUser,
        navigateData: state.systemReducer.navigateData,
    }
}

function mapStateToMethod(dispatch) {
    return {
        shrinNavigateStauts: function () {
            return dispatch(shrinNavigateStauts());
        },
        updateNavigateLevel2Data: function (title, data) {
            return dispatch(updateNavigateLevel2Data(title, data));
        }
    }
}

export default connect(mapStateToProps, mapStateToMethod)(OriginalManuscript);